import { useMemo, useState } from 'react';
import { AppErrorBoundaryComponent } from '../../../../../components/error-boundary/app-error-boundary.component';
import { ReportsComponentProps } from '../../../../../components/reports/interfaces/reports-component-props';
import {
  ChildrenComponent,
  getDrilldownFilterSelection,
} from './children.component';

import './tree.component.scss';

export interface TreeComponentProps extends ReportsComponentProps {
  excludeMode?: boolean;
}
export const TreeComponent = ({
  filterSelection,
  enabled,
  className,
  excludeMode,
}: TreeComponentProps) => {
  const [level] = useState(1);
  const filterSel = useMemo(() => {
    return getDrilldownFilterSelection(filterSelection, level);
  }, [level, filterSelection]);

  return (
    <div className={`compact-view-main ${className}`}>
      <AppErrorBoundaryComponent>
        <ChildrenComponent
          filterSelection={filterSel}
          level={level}
          enabled={enabled}
          sortBy={undefined}
          defaultExcludeMode={excludeMode}
        />
      </AppErrorBoundaryComponent>
    </div>
  );
};
